<template>
  <div
    ref="MainContent"
    class="fixed top-0 z-30 flex items-center justify-center w-full h-screen left-full"
  >
    <div
      data-dialog-box
      class="relative z-10 w-11/12 max-w-md px-5 bg-white py-14 rounded-xl"
    >
      <p
        class="mb-10 font-bold text-center text-primary"
        v-html="dialog_content"
      ></p>
      <div class="flex justify-center w-full">
        <button
          @click="Close"
          aria-label="關閉"
          class="inline-block py-3 text-sm font-semibold text-white uppercase transition-colors duration-300 border border-transparent rounded-md shadow-lg md:text-base hover:md:text-secondary px-14 bg-secondary hover:md:bg-transparent hover:md:border-secondary"
        >
          關閉
        </button>
      </div>
    </div>
    <div
      data-dialog-background
      class="absolute top-0 bottom-0 left-0 right-0 z-0 bg-opacity-50 bg-zinc-200"
    ></div>
  </div>
</template>

<script>
import { Dialog } from "@/gsap/MainDialog";
export default {
  name: "MainDialog",
  data() {
    return {
      dialog_gsap: null,
    };
  },
  methods: {
    Close() {
      this.$store.commit("SetDialog", {
        status: false,
        content: this.dialog_content,
      });
    },
  },
  watch: {
    dialog_status() {
      this.dialog_status ? this.dialog_gsap.open() : this.dialog_gsap.close();
    },
  },
  computed: {
    dialog_status() {
      return this.$store.state.main_dialog.status;
    },
    dialog_content() {
      return this.$store.state.main_dialog.content;
    },
  },
  mounted() {
    this.dialog_gsap = new Dialog(this.$refs.MainContent);
    this.dialog_gsap.reset();
  },
};
</script>
